import { BlogError } from '@/exceptions/blog/blog.enum';
import { blogService } from '@/services/blog.service';
import { notificationService } from '@/services/notification.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateBlog = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ([blogId, blog]: [number, FormData]) =>
            await blogService.editBlog(blogId, blog),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog'] });
            notificationService.success("blog Updated Succesful");

        },

        onError: () => {
            throw new Error(BlogError.EDIT_ERROR);
        },
    });
};

export default useUpdateBlog;
